import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Beranda',
    component: () => import('../../components/views/Publik/Beranda.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/simfastjateng-welcome',
    name: 'Beranda2',
    component: () => import('../../components/views/Publik/Beranda2.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DataProfil',
    name: 'DataProfil',
    component: () => import('../../components/views/Publik/Profil.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Login',
    name: 'Login',
    component: () => import('../../components/views/Publik/Login.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/KontakKami',
    name: 'KontakKami',
    component: () => import('../../components/views/Publik/KontakKami.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/GIS/:id',
    name: 'GIS',
    component: () => import('../../components/views/Publik/GIS.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Riwayat',
    name: 'Riwayat',
    component: () => import('../../components/views/Publik/Riwayat.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Usulan',
    name: 'Usulan',
    component: () => import('../../components/views/Publik/Usulan.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/BankDokumen',
    name: 'BankDokumen',
    component: () => import('../../components/views/Publik/BankDokumen.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/SDALH',
    name: 'SDALH',
    component: () => import('../../components/views/Publik/SDALH.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProfilKemiskinan',
    name: 'ProfilKemiskinan',
    component: () => import('../../components/views/Publik/ProfilKemiskinan.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Dashboard',
    name: 'Dashboard',
    component: () => import('../../components/views/Dashboard/Dashboard.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Slider',
    name: 'Slider',
    component: () => import('../../components/views/Backoffice/Slider/Slider.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesSlider/:id',
    name: 'ProsesSlider',
    component: () => import('../../components/views/Backoffice/Slider/ProsesSlider.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/InfoBeranda',
    name: 'InfoBeranda',
    component: () => import('../../components/views/Backoffice/InfoBeranda/InfoBeranda.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesInfoBeranda/:id',
    name: 'ProsesInfoBeranda',
    component: () => import('../../components/views/Backoffice/InfoBeranda/ProsesInfoBeranda.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Profil',
    name: 'Profil',
    component: () => import('../../components/views/Backoffice/Profil/Profil.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesProfil/:id',
    name: 'ProsesProfil',
    component: () => import('../../components/views/Backoffice/Profil/ProsesProfil.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/User',
    name: 'User',
    component: () => import('../../components/views/Backoffice/User/User.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesUser/:id',
    name: 'ProsesUser',
    component: () => import('../../components/views/Backoffice/User/ProsesUser.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/LayerPeta',
    name: 'LayerPeta',
    component: () => import('../../components/views/Backoffice/LayerPeta/LayerPeta.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Dokumen',
    name: 'Dokumen',
    component: () => import('../../components/views/Backoffice/Dokumen/Dokumen.vue'),
    meta: {
      transition: "zoom",
    },
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  mode: 'history',
  routes: routes,
  linkActiveClass: 'active',
})

export default router;
